export function openURL(url) {
  window.location.replace(url);
}

export function addEventListener() {

}
